export enum FeeEntryType {
  Generic = 0,
  RepaymentPrediction,
}
